const COPY = {
    en: {
        title: "Connection Mode",
        subtitle: "Choose how Ava connects.",
        online: "Online",
        local: "Offline Local",
        onlineDescription: "Cloud reasoning, live information, integrations, cloud voice input, and cloud voice output may be used.",
        localDescription: "Cloud providers, live tools, integrations, cloud speech recognition, and cloud voice output remain blocked.",
        selected: "Selected",
        effective: "Effective",
        checking: "Checking connection mode…",
        switching: "Switching…",
        reconnecting: "Reconnecting",
        disconnected: "Disconnected",
        limited: "Limited local capability",
        onlineConfirmed: "Online mode is confirmed. Network services may now be used.",
        localConfirmed: "Offline Local mode is confirmed. Cloud services are blocked.",
        localLimitedConfirmed: "Offline Local mode is confirmed. Cloud services are blocked, and local capability is currently limited.",
        localUnavailable: "Offline Local remains selected, but the protected local service is unavailable. Cloud services remain blocked.",
        localVoiceInputUnavailable: "Voice input is unavailable in Offline Local mode because no protected on-device speech recognition engine is installed. Typed chat remains available.",
        localVoiceOutputDeviceOnly: "Voice output in Offline Local mode uses only the device browser voice when available.",
        cloudBlocked: "Cloud services blocked",
        retry: "Retry",
        unavailable: "Unable to confirm the connection-mode change.",
        authRequired: "Sign in again to manage the saved account connection mode.",
    },
    es: {
        title: "Modo de conexión",
        subtitle: "Elige el modo En línea conectado a la nube o el modo Local sin conexión y aislado.",
        online: "En línea",
        local: "Local sin conexión",
        onlineDescription: "Se pueden usar razonamiento en la nube, información en vivo, integraciones, entrada de voz y salida de voz en la nube.",
        localDescription: "Los proveedores en la nube, las herramientas en vivo, las integraciones y la voz en la nube permanecen bloqueados.",
        selected: "Seleccionado",
        effective: "Efectivo",
        checking: "Comprobando el modo de conexión…",
        switching: "Cambiando…",
        reconnecting: "Reconectando",
        disconnected: "Desconectado",
        limited: "Capacidad local limitada",
        onlineConfirmed: "El modo En línea está confirmado. Ahora se pueden usar los servicios de red.",
        localConfirmed: "El modo Local sin conexión está confirmado. Los servicios en la nube están bloqueados.",
        localLimitedConfirmed: "El modo Local sin conexión está confirmado. Los servicios en la nube están bloqueados y la capacidad local es limitada.",
        localUnavailable: "El modo Local sin conexión sigue seleccionado, pero el servicio local protegido no está disponible. La nube permanece bloqueada.",
        localVoiceInputUnavailable: "La entrada de voz no está disponible en el modo Local sin conexión porque no hay un motor protegido de reconocimiento de voz instalado. El chat escrito sigue disponible.",
        localVoiceOutputDeviceOnly: "La salida de voz en modo Local sin conexión usa únicamente la voz del navegador del dispositivo cuando está disponible.",
        cloudBlocked: "Servicios en la nube bloqueados",
        retry: "Reintentar",
        unavailable: "No se pudo confirmar el cambio de modo de conexión.",
        authRequired: "Vuelve a iniciar sesión para administrar el modo de conexión guardado de la cuenta.",
    },
    fr: {
        title: "Mode de connexion",
        subtitle: "Choisissez le mode En ligne connecté au cloud ou le mode Local hors ligne isolé.",
        online: "En ligne",
        local: "Local hors ligne",
        onlineDescription: "Le raisonnement cloud, les informations en direct, les intégrations et les services vocaux cloud peuvent être utilisés.",
        localDescription: "Les fournisseurs cloud, les outils en direct, les intégrations et les services vocaux cloud restent bloqués.",
        selected: "Sélectionné",
        effective: "Effectif",
        checking: "Vérification du mode de connexion…",
        switching: "Changement…",
        reconnecting: "Reconnexion",
        disconnected: "Déconnecté",
        limited: "Capacité locale limitée",
        onlineConfirmed: "Le mode En ligne est confirmé. Les services réseau peuvent maintenant être utilisés.",
        localConfirmed: "Le mode Local hors ligne est confirmé. Les services cloud sont bloqués.",
        localLimitedConfirmed: "Le mode Local hors ligne est confirmé. Les services cloud sont bloqués et la capacité locale est limitée.",
        localUnavailable: "Le mode Local hors ligne reste sélectionné, mais le service local protégé est indisponible. Le cloud reste bloqué.",
        localVoiceInputUnavailable: "La saisie vocale est indisponible en mode Local hors ligne, car aucun moteur protégé de reconnaissance vocale n’est installé. Le chat écrit reste disponible.",
        localVoiceOutputDeviceOnly: "La sortie vocale en mode Local hors ligne utilise uniquement la voix du navigateur de l’appareil lorsqu’elle est disponible.",
        cloudBlocked: "Services cloud bloqués",
        retry: "Réessayer",
        unavailable: "Impossible de confirmer le changement de mode de connexion.",
        authRequired: "Reconnectez-vous pour gérer le mode de connexion enregistré du compte.",
    },
    de: {
        title: "Verbindungsmodus",
        subtitle: "Wähle den cloudverbundenen Online-Modus oder den isolierten lokalen Offline-Modus.",
        online: "Online",
        local: "Lokal offline",
        onlineDescription: "Cloud-Denken, Live-Informationen, Integrationen sowie Cloud-Spracheingabe und -ausgabe können verwendet werden.",
        localDescription: "Cloud-Anbieter, Live-Werkzeuge, Integrationen und Cloud-Sprachdienste bleiben gesperrt.",
        selected: "Ausgewählt",
        effective: "Aktiv",
        checking: "Verbindungsmodus wird geprüft…",
        switching: "Wechsel läuft…",
        reconnecting: "Verbindung wird wiederhergestellt",
        disconnected: "Getrennt",
        limited: "Eingeschränkte lokale Funktion",
        onlineConfirmed: "Der Online-Modus wurde bestätigt. Netzwerkdienste können jetzt verwendet werden.",
        localConfirmed: "Der lokale Offline-Modus wurde bestätigt. Cloud-Dienste sind gesperrt.",
        localLimitedConfirmed: "Der lokale Offline-Modus wurde bestätigt. Cloud-Dienste sind gesperrt und die lokale Funktion ist eingeschränkt.",
        localUnavailable: "Der lokale Offline-Modus bleibt ausgewählt, aber der geschützte lokale Dienst ist nicht verfügbar. Cloud-Dienste bleiben gesperrt.",
        localVoiceInputUnavailable: "Die Spracheingabe ist im lokalen Offline-Modus nicht verfügbar, da keine geschützte lokale Spracherkennung installiert ist. Texteingabe bleibt verfügbar.",
        localVoiceOutputDeviceOnly: "Die Sprachausgabe im lokalen Offline-Modus verwendet nur die Browserstimme des Geräts, wenn sie verfügbar ist.",
        cloudBlocked: "Cloud-Dienste gesperrt",
        retry: "Erneut versuchen",
        unavailable: "Der Wechsel des Verbindungsmodus konnte nicht bestätigt werden.",
        authRequired: "Melde dich erneut an, um den gespeicherten Verbindungsmodus des Kontos zu verwalten.",
    },
    it: {
        title: "Modalità di connessione",
        subtitle: "Scegli la modalità Online connessa al cloud oppure la modalità Locale offline e isolata.",
        online: "Online",
        local: "Locale offline",
        onlineDescription: "Possono essere usati ragionamento cloud, informazioni in tempo reale, integrazioni e servizi vocali cloud.",
        localDescription: "Provider cloud, strumenti in tempo reale, integrazioni e servizi vocali cloud restano bloccati.",
        selected: "Selezionata",
        effective: "Effettiva",
        checking: "Controllo della modalità di connessione…",
        switching: "Cambio in corso…",
        reconnecting: "Riconnessione",
        disconnected: "Disconnessa",
        limited: "Capacità locale limitata",
        onlineConfirmed: "La modalità Online è confermata. Ora possono essere usati i servizi di rete.",
        localConfirmed: "La modalità Locale offline è confermata. I servizi cloud sono bloccati.",
        localLimitedConfirmed: "La modalità Locale offline è confermata. I servizi cloud sono bloccati e la capacità locale è limitata.",
        localUnavailable: "La modalità Locale offline resta selezionata, ma il servizio locale protetto non è disponibile. Il cloud resta bloccato.",
        localVoiceInputUnavailable: "L’ingresso vocale non è disponibile in modalità Locale offline perché non è installato un motore protetto di riconoscimento vocale. La chat scritta resta disponibile.",
        localVoiceOutputDeviceOnly: "L’uscita vocale in modalità Locale offline usa soltanto la voce del browser del dispositivo, quando disponibile.",
        cloudBlocked: "Servizi cloud bloccati",
        retry: "Riprova",
        unavailable: "Impossibile confermare il cambio della modalità di connessione.",
        authRequired: "Accedi nuovamente per gestire la modalità di connessione salvata dell’account.",
    },
    pt: {
        title: "Modo de conexão",
        subtitle: "Escolha o modo Online conectado à nuvem ou o modo Local offline e isolado.",
        online: "Online",
        local: "Local offline",
        onlineDescription: "Raciocínio na nuvem, informações ao vivo, integrações e serviços de voz na nuvem podem ser usados.",
        localDescription: "Provedores de nuvem, ferramentas ao vivo, integrações e serviços de voz na nuvem permanecem bloqueados.",
        selected: "Selecionado",
        effective: "Efetivo",
        checking: "Verificando o modo de conexão…",
        switching: "Alterando…",
        reconnecting: "Reconectando",
        disconnected: "Desconectado",
        limited: "Capacidade local limitada",
        onlineConfirmed: "O modo Online foi confirmado. Os serviços de rede agora podem ser usados.",
        localConfirmed: "O modo Local offline foi confirmado. Os serviços de nuvem estão bloqueados.",
        localLimitedConfirmed: "O modo Local offline foi confirmado. Os serviços de nuvem estão bloqueados e a capacidade local está limitada.",
        localUnavailable: "O modo Local offline continua selecionado, mas o serviço local protegido está indisponível. A nuvem continua bloqueada.",
        localVoiceInputUnavailable: "A entrada de voz não está disponível no modo Local offline porque não há um mecanismo protegido de reconhecimento de voz instalado. O chat digitado continua disponível.",
        localVoiceOutputDeviceOnly: "A saída de voz no modo Local offline usa apenas a voz do navegador do dispositivo, quando disponível.",
        cloudBlocked: "Serviços de nuvem bloqueados",
        retry: "Tentar novamente",
        unavailable: "Não foi possível confirmar a alteração do modo de conexão.",
        authRequired: "Entre novamente para gerenciar o modo de conexão salvo da conta.",
    },
};
function normalizeLanguage(language) {
    return String(language || "en")
        .trim()
        .toLowerCase()
        .split("-", 1)[0];
}
export function getConnectionModeCopy(language) {
    const normalized = normalizeLanguage(language);
    return (COPY[normalized] ||
        COPY.en);
}
const COMMANDS = {
    en: {
        online: [
            "ava online",
            "ava go online",
            "go online",
            "online mode",
        ],
        local: [
            "ava offline",
            "ava go offline",
            "go offline",
            "offline mode",
            "local mode",
        ],
    },
    es: {
        online: [
            "ava en linea",
            "ava conectada",
            "modo en linea",
        ],
        local: [
            "ava sin conexion",
            "modo sin conexion",
            "modo local",
        ],
    },
    fr: {
        online: [
            "ava en ligne",
            "mode en ligne",
        ],
        local: [
            "ava hors ligne",
            "mode hors ligne",
            "mode local",
        ],
    },
    de: {
        online: [
            "ava online",
            "online modus",
        ],
        local: [
            "ava offline",
            "offline modus",
            "lokaler modus",
        ],
    },
    it: {
        online: [
            "ava online",
            "modalita online",
        ],
        local: [
            "ava offline",
            "modalita offline",
            "modalita locale",
        ],
    },
    pt: {
        online: [
            "ava online",
            "modo online",
        ],
        local: [
            "ava offline",
            "modo offline",
            "modo local",
        ],
    },
};
function normalizeCommand(value) {
    return String(value || "")
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^\p{L}\p{N}\s]/gu, " ")
        .replace(/\s+/g, " ")
        .trim();
}
export function detectConnectionModeCommand(value) {
    const normalized = normalizeCommand(value);
    if (!normalized) {
        return null;
    }
    for (const commandSet of Object.values(COMMANDS)) {
        if (commandSet.online.some((phrase) => normalized === phrase ||
            normalized.endsWith(` ${phrase}`))) {
            return "online";
        }
        if (commandSet.local.some((phrase) => normalized === phrase ||
            normalized.endsWith(` ${phrase}`))) {
            return "local";
        }
    }
    return null;
}
